import { parse } from "query-string";
import * as React from "react";
import * as yup from "yup";
import styled from "styled-components";
import * as H from "history";

import Grid from "src/library/components/Hedron";
import { BrandSplitView } from "src/library/components/BrandSplitView";
import {
  Form,
  IFormField
} from "src/library/components/Forms";
import { Text } from "src/library/components/Text";
import PoweredByMezze from "src/library/components/PoweredByMezze/PoweredByMezze";
import { Logo } from "src/core/shared/components/Logo";
import { useAuth } from "src/core/shared/api/auth";
import { PageProps } from "src/pages/Router/routes";

import {
  AuthFooter,
  AuthFormWrapper,
  AuthInner
} from "./LoginPage";

const forgotPasswordFormFields: IFormField[] = [
  {
    type: "input",
    name: "username",
    label: "Email",
    placeholder: "Email",
    autoComplete: "off",
    validation: yup
      .string()
      .trim()
      .email()
      .strict(false)
      .required("Email is required")
  }
];

const resetForgottenPassword = (verificationCode?: string | null): IFormField[] => ([
  {
    type: "input",
    name: "awsCode",
    label: "Verification Code",
    placeholder: "Verification Code",
    value: verificationCode,
    autoComplete: "off",
    validation: yup
      .string()
      .min(6)
      .required("Verification Code is required")
  },
  {
    type: "input",
    name: "newPassword",
    inputType: "password",
    label: "New Password",
    placeholder: "New Password",
    autoComplete: "off",
    validation: yup
      .string()
      .min(1)
      .required("New Password is required")
  }
]);

/**
 * Main "ForgotPassword" View
 *
 * @param {*} { user, getUserByPayroll, history }
 * @returns
 */
const ForgotPasswordPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const { enterCode, email } = parse(props.location.search);
  const [ { forgotPassword, confirmResetForgottenPassword }, { error, resettingPassword } ] = useAuth(true, props.history as H.History<{from?: string}>);
  const [ forgotPasswordUsername, setForgotPasswordUsername ] = React.useState("");

  React.useEffect(() => {
    if (typeof email === "string") {
      setForgotPasswordUsername(email);
    }
  }, [ email ]);

  return (
    <BrandSplitView>
      <AuthInner direction="vertical">
        <Grid.Box>
          <StyledDarkLogo />
        </Grid.Box>

        <Grid.Box>
          <Text
            fontSize="h4"
            color="secondary"
          >
            Forgot password
          </Text>
        </Grid.Box>

        <AuthFormWrapper>
          {(resettingPassword || enterCode?.length) ? (
            <Form
              autoHideLabels
              error={error}
              submitting={false}
              fields={resetForgottenPassword(enterCode as string | null)}
              onSubmit={({ awsCode, newPassword }) => {
                confirmResetForgottenPassword(forgotPasswordUsername, awsCode, newPassword);
              }}
              submitButtonText="Submit"
              submitButtonAlignment="center"
            />
          ) : (
            <Form
              autoHideLabels
              error={error}
              submitting={false}
              fields={forgotPasswordFormFields}
              onSubmit={({ username }) => {
                setForgotPasswordUsername(username);
                forgotPassword(username);
              }}
              submitButtonText="Get new password"
              submitButtonAlignment="center"
            />
          )}
        </AuthFormWrapper>

        <AuthFooter>
          <PoweredByMezze type="light" />
        </AuthFooter>
      </AuthInner>
    </BrandSplitView>
  );
};

const StyledDarkLogo = styled(Logo).attrs({ type: "dark" })`
  margin-bottom: 30px;
  max-width: 400px;
`;

export default ForgotPasswordPage;
